import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { MdAdd, MdAddAPhoto, MdDeleteForever, MdEdit, MdLink, MdOutlineDeleteForever } from "react-icons/md";
import Cookies from "js-cookie";
import demowallpaper from "../assets/editer_imgs/demowallpaper.jpg";
import Editerslideshow from "./components_editer/editerslideshow";
import "./editer_home.css";
import Loadingimg from "../components_root/loadingimg";
import { Uploader_files } from "../components_root/uploader_files";
import { No_transactions } from "../components_root/no_transactions";
import { Randomcode } from "../components_root/rendom_code";
import ProEditor from "./EditorPad";
import { Delete_page } from "./delete_page";
import {
    getDocs,
    query,
    collection,
    where,
    orderBy, onSnapshot
} from "firebase/firestore";
import { db } from "../firebase";
import { Toast } from "../components_root/ToastContext";
import { Create_contents } from "./create_contents";
export const seo = {
    title: "Online Tools & Digital Services | Productivity, SEO & File Conversion",
    description:
        "Explore free and premium online tools including word counters, file converters, favicon generators, SEO analyzers, and text utilities.",
    keywords:
        "online tools, productivity tools, seo tools, file converter, word counter"
};
export default function Editer_home() {
    const { Toastshow } = Toast();
    const navigate = useNavigate();

    const [pageuid, setpageuid] = useState();

    const [page_name, setpage_name] = useState("");
    const [page_title, setpage_title] = useState("");
    const [page_description, setpage_description] = useState("");
    const [page_button_name, setpage_button_name] = useState("More Info");
    const [page_button_link, setpage_button_link] = useState("");
    const [page_keywords, setpage_keywords] = useState("");
    const [page_editdata, setPage_editdata] = useState([]);
    const [loading, setLoading] = useState(true);
    //
    const [pluginsdata, setpluginsdata] = useState([]);

    const [companyuid] = useState(
        Cookies.get("website_company_uid")
    );
    //slide
    const [slide_name, setsilde_name] = useState("");
    const [slide_description, setslide_description] = useState("");

    //slide file

    const [contentdata, setcontentdata] = useState([]);
    const [contenttextdata, setcontenttextdata] = useState([]);
    const [old_file_uid, setOld_file_uid] = useState("");

    const [old_banner_file_uid, setOld_banner_file_uid] = useState("");
    const [banner_file, setBanner_file] = useState(null);
    const [BannerUrl, setBannerUrl] = useState("");
    const editorRef = useRef();
    const [content, setContent] = useState('');

    useEffect(() => {
        const guids = Cookies.get("guid");

        if (!guids || guids === "undefined" || guids === null) {
            navigate("/");
        }
    }, [navigate, companyuid]);

    // ================= FETCH =================
    const fetchData = async () => {
        try {
            if (!companyuid) return;

            setLoading(true);

            const companySnap = await getDocs(
                query(
                    collection(db, "companies", companyuid, "pages"),
                    where("slug", "==", "home")
                )
            );

            if (!companySnap.empty) {
                const data = companySnap.docs.map(doc => ({
                    ...doc.data(),
                    uid: doc.id
                }));

                const first = data[0] || {};

                // ✅ SAFE SET
                setpageuid(first.pageuid);
                setpage_name(first.page_name || "");
                setpage_title(data[0].page_title);
                setpage_description(first.page_description || "");
                setpage_keywords(first.page_keywords || "");

                setPage_editdata(data);
            } else {
                setPage_editdata([]);
            }

        } catch (err) {
            console.error("Error:", err);
            Toastshow("Failed to load data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [companyuid]);

    //get pluginsdata
    useEffect(() => {
        const fetch_pluginsData = async () => {
            try {
                if (!companyuid || !pageuid) return; // ✅ FIX

                setLoading(true);

                const pluginsRef = collection(
                    db,
                    "companies",
                    companyuid,
                    "pages",
                    pageuid,
                    "plugins"
                )

                // ✅ REMOVE where if not needed
                const companySnap = await getDocs(pluginsRef,
                    where("status", "==", true),
                    orderBy("indexnumber", "asc"));

                if (!companySnap.empty) {
                    const data = companySnap.docs.map(doc => ({
                        ...doc.data(),
                        uid: doc.id
                    }));

                    setpluginsdata(data);
                } else {
                    setpluginsdata([]);
                }

            } catch (err) {
                console.error("Error:", err);
                Toastshow("Failed to load pluginsdata");
            } finally {
                setLoading(false);
            }
        };
        fetch_pluginsData();
    }, [companyuid, pageuid]);

    //get home_silde contentdata
    useEffect(() => {


        if (!companyuid || !pageuid) return;

        setLoading(true);

        const ref = collection(
            db,
            "companies",
            companyuid,
            "pages",
            pageuid,
            "contentdata"
        );

        const q = query(
            ref,
            where("status", "==", true),
            //  where("category", "==", "home_silde"),  
            orderBy("indexnumber", "asc")
        );

        const unsubscribe = onSnapshot(
            q,
            (snapshot) => {
                if (snapshot.empty) {
                    setcontentdata([]);
                    setLoading(false);
                    return;
                }

                const data = snapshot.docs.map((doc) => ({
                    ...doc.data(),
                    uid: doc.id
                }));

                setcontentdata(data);
                setLoading(false);
            },
            (err) => {
                console.error("❌ Firestore Error:", err);
                Toastshow("Failed to load content");
                setLoading(false);
            }
        );

        return () => unsubscribe();

    }, [companyuid, pageuid]);
    const banner_Upload = async () => {
        try {
            if (!slide_name) {
                setBanner_file(null);
                Toastshow("Enter slide name");
                return;
            }

            const contentuid = Randomcode(18);
            const res = await Create_contents({
                title: slide_name,
                description: slide_description,
                button_link: page_button_link,
                button_name: page_button_name,
                keywords: "slide_name",
                category: "home_silde",
                datafiles: "",
                slug: "",
                pluguid: "rBCnU6XMGG",
                status: true,
                pageuid,
                companyuid,
                contentuid,
            });

            if (!res?.success) {
                Toastshow("Slide create failed");
                return;
            }

            if (!banner_file) return;

            if (!Cookies.get("guid")) {
                Toastshow("Please login");
                return;
            }


            const fileuid = Randomcode(22);

            const result = await Uploader_files({
                fileuid,
                companyuid,
                pageuid,
                file: banner_file,
                filename: "homesilde", //no space
                //update under file
                fileupdate: true,
                tablename: "contentdata",
                contentuid: contentuid,
                //delete old file
                old_file_uid: "",
            });


            if (result?.success) {
                Toastshow("Successfully!");
                setslide_description("");
                setsilde_name("");
                setpage_button_link("");
                setpage_button_name("");
                setBanner_file(null);
            } else {
                Toastshow(`Error: ${result?.error || "Upload failed"}`);
                setBanner_file(null);
            }

        } catch (err) {
            console.error("❌ Upload crash:", err);
            Toastshow("Upload failed!");
            setBanner_file(null);
        }
    };
    useEffect(() => {
        if (!banner_file) return;

        banner_Upload();

    }, [banner_file, companyuid]);

    const save_Create_contents = async (title, description, keywords, category, linkurl, plugin, pluguid, pluginstalluid, contentuid) => {

        if (contentuid.length < 13) {
            contentuid = Randomcode(18);
        }
        if (!title) {
            return
        }
        const result = await Create_contents({
            title,
            description,
            keywords,
            plugin,
            pluguid,
            pluginstalluid,
            category: category,
            datafiles: "",
            slug: "",
            linkurl,
            status: true,
            pageuid,
            companyuid,
            contentuid,
        });
        if (result?.success) {
            Toastshow("Successfully!");
        } else {
            Toastshow(`Error: ${result?.error || "failed"}`);

        }
    }

    const handleSave_Text = (pluginstalluid, contentuid) => {
        const html = editorRef.current.innerHTML;
        save_Create_contents("home about", html, "keywords", "text_message", "linkurl", "Text", "Pg7cY0Q1jl", pluginstalluid, contentuid)
        // Save to backend...
    };
    // useEffect(() => {
    //     const get_contenttextdata = async () => {
    //         if (!companyuid || !pageuid) return;

    //         setLoading(true);

    //         const q = query(
    //             collection(db, "companies", companyuid, "pages", pageuid, "contentdata"),
    //             where("status", "==", true),
    //             orderBy("indexnumber", "asc")
    //         );

    //         // ✅ REAL-TIME LISTENER
    //         const unsubscribe = onSnapshot(
    //             q,
    //             (snapshot) => {
    //                 const data = snapshot.docs.map(doc => ({
    //                     ...doc.data(),
    //                     uid: doc.id
    //                 }));

    //                 setcontenttextdata(data);
    //                 setLoading(false);
    //             },
    //             (err) => {
    //                 console.error("Error:", err);
    //                 //Toastshow("Failed to load content");
    //                 setLoading(false);
    //             }
    //         );

    //         // ✅ CLEANUP (IMPORTANT)
    //         return () => unsubscribe();

    //     }

    //     get_contenttextdata();
    // }, [companyuid, pageuid]);

    const [qlinktitle, setQlinktitle] = useState();
    const [qlinkurl, setQlinkurl] = useState();
    const save_quickdoc_contents = (pluginstalluid) => {
        if (!qlinktitle) {
            Toastshow("Enter name");
            return
        }
        if (!qlinkurl) {
            Toastshow("Enter url");
            return
        }
        save_Create_contents(qlinktitle, qlinktitle, "keywords", qlinktitle, qlinkurl, "QuickDock", "UwRQEKVnx0", pluginstalluid)
        setQlinktitle("");
        setQlinkurl("");
    }

    useEffect(() => {
        if (contentdata?.length > 0) {
            const item = contentdata.find(
                (row) => row.pluguid === "Pg7cY0Q1jl"
            );

            if (item) {
                setContent(item.description);
            }
        }
    }, [contentdata]);

    return (
        <div>
            <Helmet>
                <title>{page_title || seo.title}</title>
                <meta name="description" content={page_description || seo.description} />
                <meta name="keywords" content={page_keywords || seo.keywords} />
                <meta property="og:title" content={page_name || seo.title} />
                <meta property="og:description" content={page_description || seo.description} />
            </Helmet>

            {/* Content */}
            <div className="container_roots">
                <div className="ui-grid-fill">
                    {loading ? (
                        <div>Loading...</div>
                    ) : pluginsdata.length === 0 ? (
                        <No_transactions message="Plugin not installed" />
                    ) : (
                        pluginsdata.map((item) => (
                            <>
                                {/* Slideshow*/}
                                {item.pluguid === "rBCnU6XMGG" && (
                                    <div key={item.uid} className="silde_body">

                                        {contentdata?.length > 0 && (
                                            <Editerslideshow
                                                slideshow_filedata={
                                                    contentdata.filter(item => item.pluguid === "rBCnU6XMGG")
                                                }
                                                banner_default={demowallpaper}
                                            />
                                        )}
                                        <div className="create_body b-1  items-back-fill rounded">
                                            <table>
                                                <tr>
                                                    <td>
                                                        <table>
                                                            <tr>
                                                                <td>
                                                                    <input className="p-1 border-none" maxLength={30} value={slide_name} onChange={(e) => setsilde_name(e.target.value)} placeholder="Silde title" />


                                                                </td>

                                                            </tr>

                                                            <tr>

                                                                <td>
                                                                    <textarea className="p-1 border-none text-h3" maxLength={100} rows="4" value={slide_description} onChange={(e) => setslide_description(e.target.value)} placeholder="Enter description
                                                                    If description is null (or empty), don’t show the content at all" />


                                                                </td>

                                                            </tr>
                                                            <tr>
                                                                <td>

                                                                    <input className="p-1 border-none" maxLength={30} value={page_button_name} onChange={(e) => setpage_button_name(e.target.value)} placeholder="Button name" />


                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>

                                                                    <input className="p-1 border-none" maxLength={100} value={page_button_link} onChange={(e) => setpage_button_link(e.target.value)} placeholder="Button link" />


                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-off">*Required: Image size must be exactly 1920 × 900 pixels</td>
                                                            </tr>
                                                            <tr>
                                                                <td>

                                                                    {banner_file ? (
                                                                        <div className="button-ui fill center">< Loadingimg className="icon" /></div>

                                                                    ) : (
                                                                        <>
                                                                            <label htmlFor="bannerInput" className="cursor">
                                                                                <div className="button-ui3 fill">
                                                                                    <MdAddAPhoto className="icon cursor" />
                                                                                    Upload Banner
                                                                                </div>
                                                                            </label>

                                                                            <input
                                                                                type="file"
                                                                                accept=".jpg,.jpeg,.png"
                                                                                style={{ display: "none" }}
                                                                                id="bannerInput"
                                                                                onChange={(e) => {
                                                                                    const selectedFile = e.target.files[0];
                                                                                    if (!selectedFile) return;

                                                                                    const img = new Image();
                                                                                    const objectUrl = URL.createObjectURL(selectedFile);

                                                                                    img.onload = () => {
                                                                                        const width = img.width;
                                                                                        const height = img.height;

                                                                                        if (width === 1920 && height === 900) {
                                                                                            // ✅ valid
                                                                                            setBanner_file(selectedFile);
                                                                                            setBannerUrl(objectUrl);
                                                                                        } else {
                                                                                            // ❌ invalid
                                                                                            Toastshow("Image must be exactly 1920 × 900 pixels");

                                                                                            URL.revokeObjectURL(objectUrl);
                                                                                            e.target.value = ""; // reset input
                                                                                        }
                                                                                    };

                                                                                    img.src = objectUrl;
                                                                                }}
                                                                            />
                                                                        </>
                                                                    )}

                                                                </td>
                                                            </tr>
                                                        </table>

                                                    </td>

                                                </tr>
                                            </table>

                                        </div>

                                    </div>
                                )}
                                {/* Gallery*/}
                                {item.pluguid === "CCmMD23uB3" && (
                                    <div key={item.uid} className="m-top">
                                        <div className="bold">
                                            {item.plugins_name || "Untitled"}
                                        </div>
                                        <div className="bold">
                                            {item.pluguid || "Untitled"}
                                        </div>
                                    </div>
                                )}
                                {/* Download */}
                                {item.pluguid === "3mPZGgUnGt" && (
                                    <div key={item.uid} className="m-top">
                                        <div className="bold">
                                            {item.plugins_name || "Untitled"}
                                        </div>
                                        <div className="bold">
                                            {item.pluguid || "Untitled"}
                                        </div>
                                    </div>
                                )}
                                {/* Text */}
                                {item.pluguid === "Pg7cY0Q1jl" && (
                                    <div className="post-container mtop" key={item.uid}>


                                        <div className="post_div ">

                                            <ProEditor
                                                ref={editorRef}
                                                initialValue={content}
                                                onChange={setContent}
                                                placeholder="Write something..."
                                            />
                                            <table>
                                                <tr>
                                                    <td>
                                                        <div
                                                            className="button-ui cursor p-11"
                                                            onClick={() => {
                                                                let contentuid = "new";   // ✅ use let

                                                                if (contentdata?.length > 0) {
                                                                    const items = contentdata.find(
                                                                        (rows) => rows.pluguid === "Pg7cY0Q1jl"
                                                                    );

                                                                    if (items && content.length > 0) {
                                                                        contentuid = items.contentuid;
                                                                    }
                                                                }

                                                                handleSave_Text(item.pluginstalluid, contentuid);
                                                            }}
                                                        >
                                                            Save
                                                        </div>
                                                    </td>
                                                    <td width={60}>
                                                        <div className="button-ui3 red cursor"  ><MdOutlineDeleteForever className="icon" />Delete</div>
                                                    </td>
                                                </tr>
                                            </table>

                                            {/* <div dangerouslySetInnerHTML={{ __html: content }} /> */}

                                        </div>

                                        {pluginsdata
                                            ?.find(p => p.pluguid === "UwRQEKVnx0") && (
                                                <div className="post_updates">

                                                    <table>
                                                        <tr>
                                                            <td>
                                                                <div className="bold">
                                                                    {pluginsdata.find(p => p.pluguid === "UwRQEKVnx0")?.plugins_name || "Untitled"}
                                                                </div>
                                                            </td>
                                                            <td width={60}>
                                                                <div className="button-ui3 red cursor"  ><MdOutlineDeleteForever className="icon" />Delete</div>
                                                            </td>
                                                        </tr>

                                                    </table>
                                                    <div>
                                                        <table>
                                                            <tr>

                                                                <td>
                                                                    <input
                                                                        name="title"
                                                                        maxLength={30}
                                                                        placeholder="Title"
                                                                        value={qlinktitle}
                                                                        onChange={(e) => setQlinktitle(e.target.value)}
                                                                    />
                                                                </td>

                                                                <td>
                                                                    <input
                                                                        name="linkurl"
                                                                        maxLength={200}
                                                                        placeholder="Page url link"
                                                                        value={qlinkurl}
                                                                        onChange={(e) => setQlinkurl(e.target.value)}
                                                                    />
                                                                </td>

                                                                <td width={60}>
                                                                    <div onClick={() => save_quickdoc_contents(item.pluginstalluid)} className="button-ui p-11 cursor">
                                                                        Save
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                        <div className="ui-guid">
                                                            {contentdata?.length > 0 &&

                                                                contentdata.filter(item => item.pluguid === "UwRQEKVnx0")
                                                                    .map((row, index) => (
                                                                        <div className="ui-items b-1 rounded p-1" key={index}>
                                                                            <table>
                                                                                <tr>
                                                                                    <td width={20}><MdLink /></td>
                                                                                    <td className="bold">
                                                                                        {row.title}
                                                                                    </td>
                                                                                    <td className="text-r blue u-hover">
                                                                                        <a href={row.linkurl}>{row.linkurl}</a>
                                                                                    </td>
                                                                                    <td width={25}  ><MdDeleteForever
                                                                                        onClick={() => {

                                                                                            Delete_page({
                                                                                                contentdata: "contentdata",
                                                                                                fileuid: "",
                                                                                                pageuid: pageuid,
                                                                                                contentuid: row.contentuid,
                                                                                                companyuid: companyuid
                                                                                            }).then((res) => {
                                                                                                if (res.success) {
                                                                                                    Toastshow("Deleted successfully");

                                                                                                } else {
                                                                                                    Toastshow("Delete failed: " + res.error);
                                                                                                }
                                                                                            });

                                                                                        }}

                                                                                        className="icon m-l cursor red" /></td>
                                                                                </tr>
                                                                            </table>

                                                                        </div>
                                                                    ))
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                    </div >
                                )}


                            </>
                        ))
                    )}


                </div>

            </div>
        </div >
    );
}